import { render, staticRenderFns } from "./UploadPublishedDoc.vue?vue&type=template&id=4b4444f0&"
import script from "./UploadPublishedDoc.vue?vue&type=script&lang=js&"
export * from "./UploadPublishedDoc.vue?vue&type=script&lang=js&"
import style0 from "./UploadPublishedDoc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports